import Loadable, { LoadingSpinner as Loading } from '@comeon/loadable';
import { useSelector } from 'react-redux';
import { authenticationSelector } from '~/components/authentication/ducks/selectors.js';
import { LICENSE_DEGA, LICENSE_DGA, LICENSE_SGA, LICENSE_OGA, LICENSE_KSA } from '~/utils/license-utils';
import { selectRegHeaderEnabled } from '../../brand/ducks/index.js';
import { selectIsDesktop, selectLicense } from '../../brand/ducks/selectors.js';
import RegulationsHeaderWrapper from './regulations-header-wrapper.js';
import { isNativeRegHeaderEnabled } from '~/components/app-bridge/app-properties.js';

const DELAY = 300;

const RegulationsHeaderSGA = Loadable({
	loader: () =>
		import(
			/* webpackChunkName: "sga-bundle" */
			'./regulations-header-sga.js'
		),
	loading: Loading,
	delay: DELAY
});

const RegulationsHeaderDEGA = Loadable({
	loader: () =>
		import(
			/* webpackChunkName: "dega-bundle" */
			'./regulations-header-dega.tsx'
		),
	loading: Loading,
	delay: DELAY
});

const RegulationsHeaderDGA = Loadable({
	loader: () =>
		import(
			/* webpackChunkName: "dga-bundle" */
			'./regulations-header-dga.js'
		),
	loading: Loading,
	delay: DELAY
});

const RegulationsHeaderOGA = Loadable({
	loader: () =>
		import(
			/* webpackChunkName: "oga-bundle" */
			'./regulations-header-oga.js'
		),
	loading: Loading,
	delay: DELAY
});

const RegulationsHeaderKSA = Loadable({
	loader: () =>
		import(
			/* webpackChunkName: "ksa-bundle" */
			'./regulations-header-ksa.js'
		),
	loading: Loading,
	delay: DELAY
});

const regulationsHeaderSGASelector = state => selectRegHeaderEnabled(state);

const regulationsHeaderDGASelector = state =>
	selectRegHeaderEnabled(state) && authenticationSelector(state) && !selectIsDesktop(state);

const regulationsHeaderDEGASelector = state => selectRegHeaderEnabled(state) && authenticationSelector(state);

const regulationsHeaderOGASelector = state => selectRegHeaderEnabled(state) && authenticationSelector(state);
const regulationsHeaderKSASelector = state => selectRegHeaderEnabled(state) && authenticationSelector(state);

const REGULATION_HEADER_SELECTORS = {
	[LICENSE_SGA]: regulationsHeaderSGASelector,
	[LICENSE_DEGA]: regulationsHeaderDEGASelector,
	[LICENSE_DGA]: regulationsHeaderDGASelector,
	[LICENSE_OGA]: regulationsHeaderOGASelector,
	[LICENSE_KSA]: regulationsHeaderKSASelector
};

/**
 * @param {unknown} state - The state object.
 * @returns {boolean}
 */
export const selectHasRegulationsHeader = state => {
	// this means mobile app is showing a native reg header
	if (isNativeRegHeaderEnabled()) return false;

	const license = selectLicense(state);
	return REGULATION_HEADER_SELECTORS[license]?.(state) ?? false;
};

const REGULATION_HEADERS = {
	[LICENSE_SGA]: RegulationsHeaderSGA,
	[LICENSE_DEGA]: RegulationsHeaderDEGA,
	[LICENSE_DGA]: RegulationsHeaderDGA,
	[LICENSE_OGA]: RegulationsHeaderOGA,
	[LICENSE_KSA]: RegulationsHeaderKSA
};

export const RegulationsHeader = () => {
	const license = useSelector(selectLicense);
	const Component = REGULATION_HEADERS[license];
	return Component ? <Component /> : null;
};

export { RegulationsHeaderWrapper };
